import { takeLatest, call, put, all } from 'redux-saga/effects';
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CRV } from 'services/_path';
import { ReducerAction } from 'store/modules/types';
import { IIpressaoRenavam } from 'pages/DetranCrv/Processos/ImpressaoRenavam/Consulta/form';
import { Types } from './types';
import { impressaoRenavamSuccess, impressaoRenavamFailure } from './actions';

function* impressaoRenavamRequest(request: ReducerAction) {
	const { payload }: { payload: IIpressaoRenavam } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CRV,
		`processos/${CHANNEL}/impressao/planilhas-renavam`,
		payload,
	);
	if (response.status === 200 || response.status === 201) {
		yield put(impressaoRenavamSuccess(response));
	} else if (response.error) {
		yield put(impressaoRenavamFailure(response.message));
	}
}

export default all([
	takeLatest(Types.IMPRESSAO_RENAVAM_REQUEST, impressaoRenavamRequest),
]);
